enum OrderOptimizerViewModel {
  CARGO = "CARGO",
  RAILY = "RAILY",
  TAXI = "TAXI",
}

export default OrderOptimizerViewModel;
